import type { LanguagePack } from './types'

export const gu: LanguagePack = {
  navSaved: 'સેવ કરેલા',
  navInfo: 'માહિતી',
  homeTitle: 'તમારા કાગળનો ફોટો પાડો',
  homeHint: 'સમજો કહેશે કે કાગળમાં શું લખ્યું છે અને તમારે આગળ શું કરવાનું છે.',
  takePhoto: 'ફોટો પાડો',
  uploadFile: 'ફોટો કે PDF મૂકો',
  supportedFiles: 'ફોટો (JPG, PNG, WEBP) કે PDF · 10 MB સુધી',
  chooseLanguage: 'કઈ ભાષામાં સમજવું છે',
  privacyLine: 'તમારો કાગળ આ જ ફોનમાં વંચાય છે. તમે "સેવ કરો" ન દબાવો ત્યાં સુધી કંઈ સેવ થતું નથી.',

  previewTitle: 'ફોટો બરાબર છે?',
  rotate: 'ફેરવો',
  crop: 'કાપો',
  cropDone: 'થઈ ગયું',
  retake: 'ફરી પાડો',
  readNow: 'વાંચો',
  docLanguageLabel: 'કાગળ કઈ ભાષામાં લખેલો છે?',
  docLanguageHint: 'અંગ્રેજી હંમેશાં સાથે વંચાય છે.',

  stepCheck: 'ફોટો તપાસાય છે…',
  stepRead: 'કાગળ વંચાય છે…',
  stepExtract: 'જરૂરી માહિતી શોધાય છે…',
  stepExplain: 'ગુજરાતીમાં સમજાવાય છે…',
  firstTimeNote: 'પહેલી વાર થોડો વધારે સમય લાગશે, કારણ કે વાંચવાનું ટૂલ ડાઉનલોડ થાય છે.',
  cancel: 'રોકો',

  errBadImage: 'ફોટો થોડો ચોખ્ખો નથી. કૃપા કરીને બીજો ચોખ્ખો ફોટો પાડો.',
  errNoText: 'સમજોને આ કાગળ પર કંઈ લખેલું મળ્યું નહીં.',
  errUnclearPart: 'સમજોથી આ ભાગ બરાબર વંચાયો નહીં.',
  errUnsupportedLanguage: 'આ ભાષાની સગવડ હજી નથી.',
  errLongDocument: 'આ કાગળ ઘણો લાંબો છે. પહેલાં જરૂરી પાનાં પસંદ કરો.',
  errFileType: 'કૃપા કરીને ફોટો (JPG, PNG, WEBP) કે PDF પસંદ કરો.',
  errFileSize: 'આ ફાઇલ 10 MB કરતાં મોટી છે. કૃપા કરીને નાની ફાઇલ પસંદ કરો.',
  errGeneric: 'કંઈક ગડબડ થઈ. કૃપા કરીને ફરી પ્રયત્ન કરો.',
  errOcrDownload: 'વાંચવાનું ટૂલ ડાઉનલોડ ન થયું. એક વાર ઇન્ટરનેટ ચાલુ કરીને ફરી પ્રયત્ન કરો.',
  warnDark: 'ફોટામાં અંધારું છે. સારા અજવાળામાં પાડેલો ફોટો બરાબર વંચાય છે.',
  warnBlurry: 'ફોટો ઝાંખો લાગે છે. ફોન સ્થિર પકડીને ફરી પાડો.',
  warnSmall: 'ફોટો બહુ નાનો છે. કાગળની નજીકથી ફોટો પાડો.',
  tryAgain: 'ફરી પ્રયત્ન કરો',

  pickPagesHint: (max) => `વધુમાં વધુ ${max} પાનાં પસંદ કરો.`,
  pageLabel: (n) => `પાનું ${n}`,
  readSelectedPages: (n) => `${n} ${n === 1 ? 'પાનું' : 'પાનાં'} વાંચો`,

  typeSure: (name) => `આ ${name} લાગે છે.`,
  typeMaybe: (name) => `આ કદાચ ${name} છે, પણ સમજોને પૂરી ખાતરી નથી.`,
  typeUnknown: 'આ કાગળ કયા પ્રકારનો છે, તેની સમજોને પૂરી ખાતરી નથી.',
  docTypes: {
    income_certificate: { name: 'આવકનો દાખલો (ઇન્કમ સર્ટિફિકેટ)', about: 'તેમાં સરકારી રેકોર્ડ પ્રમાણે કોઈ વ્યક્તિ કે કુટુંબની આવક લખેલી હોય છે.' },
    caste_certificate: { name: 'જાતિનો દાખલો', about: 'તેમાં લખેલું હોય છે કે વ્યક્તિ કઈ જાતિ કે વર્ગની છે.' },
    domicile_certificate: { name: 'રહેઠાણનો દાખલો (ડોમિસાઇલ)', about: 'તેમાં લખેલું હોય છે કે વ્યક્તિ કાયમ ક્યાં રહે છે.' },
    birth_certificate: { name: 'જન્મનો દાખલો', about: 'આ જન્મનો સરકારી રેકોર્ડ છે.' },
    death_certificate: { name: 'મરણનો દાખલો', about: 'આ મરણનો સરકારી રેકોર્ડ છે.' },
    electricity_bill: { name: 'વીજળીનું બિલ', about: 'તેમાં વપરાયેલી વીજળી અને ભરવાના પૈસા લખેલા હોય છે.' },
    water_bill: { name: 'પાણીનું બિલ', about: 'તેમાં પાણીના ભરવાના પૈસા લખેલા હોય છે.' },
    ration_card: { name: 'રેશન કાર્ડ કે રેશનની સૂચના', about: 'આ સરકારી દુકાનેથી રેશન મળવા વિશે છે.' },
    aadhaar: { name: 'આધારને લગતો કાગળ', about: 'આ આધાર નંબર કે આધારની માહિતી વિશે છે.' },
    pan_card: { name: 'પાન (PAN) ને લગતો કાગળ', about: 'આ પાન (ટેક્સ ઓળખ) નંબર વિશે છે.' },
    bank_notice: { name: 'બેંકનો પત્ર', about: 'આ બેંક તરફથી આવેલો પત્ર કે સૂચના છે.' },
    loan_notice: { name: 'લોન (દેવા)ની સૂચના', about: 'આ કોઈ લોન કે બાકી પૈસા વિશે છે.' },
    income_tax_notice: { name: 'આવકવેરા (ઇન્કમ ટેક્સ)ની સૂચના', about: 'આ આવકવેરા વિભાગ તરફથી છે.' },
    pension: { name: 'પેન્શનને લગતો પત્ર', about: 'આ પેન્શન વિશે છે.' },
    court_notice: { name: 'કોર્ટની કે કાનૂની નોટિસ', about: 'આ કોર્ટ તરફથી છે અથવા કોઈ કાનૂની બાબત વિશે છે. તેને ગંભીરતાથી લો.' },
    land_record: { name: 'જમીનનો રેકોર્ડ', about: 'આ જમીનની માલિકી કે જમીનની માહિતી વિશે છે.' },
    property_tax: { name: 'મિલકત વેરા (હાઉસ ટેક્સ)નું બિલ', about: 'આ ઘર કે મિલકતના ટેક્સ વિશે છે.' },
    scholarship: { name: 'શિષ્યવૃત્તિ (સ્કોલરશિપ)નો પત્ર', about: 'આ ભણતર માટે મળતી શિષ્યવૃત્તિ વિશે છે.' },
    farmer_scheme: { name: 'ખેડૂત યોજનાનો પત્ર', about: 'આ ખેડૂતો માટેની કોઈ યોજના કે મદદ વિશે છે.' },
    school_letter: { name: 'શાળાનો પત્ર', about: 'આ શાળા તરફથી છે અથવા ભણતર વિશે છે.' },
    marksheet: { name: 'માર્કશીટ કે પરિણામ', about: 'તેમાં પરીક્ષાના માર્ક કે પરિણામ લખેલું છે.' },
    insurance: { name: 'વીમાનો કાગળ', about: 'આ કોઈ વીમા પોલિસી વિશે છે.' },
    traffic_challan: { name: 'ટ્રાફિક ચલણ (મેમો)', about: 'આ ટ્રાફિક કે વાહનનો નિયમ તોડવા બદલનો દંડ છે.' },
    job_notice: { name: 'નોકરી કે પરીક્ષાની સૂચના', about: 'આ સરકારી નોકરી, ભરતી કે તેની પરીક્ષા વિશે છે.' },
    application_receipt: { name: 'અરજીની પહોંચ (રસીદ)', about: 'તેનાથી ખબર પડે છે કે અરજી જમા થઈ ગઈ છે.' },
    application_decision: { name: 'અરજી વિશેનો પત્ર', about: 'તેમાં કોઈ અરજીનો નિર્ણય કે માહિતી આપેલી છે.' },
    government_notice: { name: 'સરકારી સૂચના', about: 'આ કોઈ સરકારી કચેરીની સૂચના કે હુકમ છે.' },
    lab_report: { name: 'તબીબી તપાસનો રિપોર્ટ', about: 'તેમાં લોહી અથવા બીજી તબીબી તપાસનાં પરિણામો છે.' },
    rental_agreement: { name: 'ભાડા કરાર', about: 'આ મકાનમાલિક અને ભાડૂઆત વચ્ચેનો કરાર છે.' },
    loan_agreement: { name: 'લોન કરાર', about: 'તેમાં લોનની શરતો છે: વ્યાજ, EMI અને ચાર્જ.' },
    contract: { name: 'એક કરાર', about: 'આ એક કરાર છે, જેની શરતો બંને પક્ષોએ માનવાની હોય છે.' },
    unknown: { name: 'કાગળ', about: '' }
  },

  seedhiBaat: 'સીધી વાત',
  docSays: 'કાગળમાં લખ્યું છે',
  samjhoSays: 'સમજો સમજાવે છે',
  unclearText: 'આ ભાગ બરાબર વંચાયો નહીં — કૃપા કરીને અસલ કાગળ જુઓ.',

  aboutPerson: (name) => `આ કાગળ ${name} વિશે છે.`,
  issuedBy: (authority) => `આ અહીંથી આવ્યો છે: ${authority}.`,
  status: {
    approved: 'અરજી મંજૂર થઈ ગઈ છે.',
    rejected: 'અરજી નામંજૂર (રિજેક્ટ) થઈ છે.',
    pending: 'અરજી પર હજી કામ ચાલે છે. હજી નિર્ણય થયો નથી.',
    cancelled: 'આ રદ કરવામાં આવ્યું છે.'
  },
  dateSentence: {
    deadline: (d) => `છેલ્લી તારીખ: ${d}.`,
    due: (d) => `પૈસા ભરવાની છેલ્લી તારીખ: ${d}.`,
    hearing: (d) => `કાગળમાં હાજર રહેવા માટે આ તારીખ આપેલી છે: ${d}.`,
    issue: (d) => `આ કાગળ ${d} ના રોજ આપવામાં આવ્યો.`,
    validity: (d) => `આ ${d} સુધી માન્ય છે.`,
    birth: (d) => `જન્મ તારીખ લખેલી છે: ${d}.`,
    other: (d) => `એક તારીખ લખેલી છે: ${d}.`
  },
  daysLeft: (days) => (days === 1 ? '1 દિવસ બાકી છે.' : `${days} દિવસ બાકી છે.`),
  dueToday: 'આ તારીખ આજે જ છે.',
  datePassed: 'ધ્યાન આપો: આ તારીખ વીતી ગઈ છે.',
  amountSentence: {
    payable: (a) => `ભરવાની રકમ: ${a}.`,
    income: (a) => `લખેલી આવક: ${a}.`,
    fine: (a) => `દંડ કે મોડું થવાનો ચાર્જ લખેલો છે: ${a}.`,
    fee: (a) => `ફી લખેલી છે: ${a}.`,
    sanctioned: (a) => `મંજૂર થયેલી કે મોકલેલી રકમ: ${a}.`,
    other: (a) => `એક રકમ લખેલી છે: ${a}.`
  },
  actionsPointer: 'કાગળમાં તમને કંઈક કરવાનું કહ્યું છે. નીચે "તમારે શું કરવાનું છે" જુઓ.',
  noActionFound: 'કાગળમાં તમને કંઈ કરવાનું છે, એવું ચોખ્ખું લખેલું નથી.',
  keepSafe: 'આ કાગળ સાચવીને રાખો.',
  doBefore: (d) => `આ કામ ${d} પહેલાં કરો.`,
  bringDocs: (list) => `આ કાગળો તૈયાર રાખો: ${list}.`,
  contactFor: (c) => `સવાલ હોય તો અહીં સંપર્ક કરો: ${c}.`,
  warningPointer: 'કાગળમાં એક ચેતવણી લખેલી છે. તેને ધ્યાનથી વાંચો.',
  rejectedNext: 'જો તમને લાગે કે ભૂલ થઈ છે, તો જે કચેરીએથી આ પત્ર આવ્યો છે, ત્યાં પૂછો.',
  lowQuality: 'ફોટો બહુ ચોખ્ખો નહોતો, એટલે કેટલીક વાતો ખોટી વંચાઈ હોઈ શકે. અસલ કાગળ સાથે મેળવી લો.',

  cardTodo: 'તમારે શું કરવાનું છે',
  cardDates: 'જરૂરી તારીખો',
  cardAmount: 'રકમ',
  cardWhere: 'ક્યાં જવાનું છે',
  cardWarnings: 'ધ્યાન રાખો',
  cardDocs: 'કયા કાગળો જોઈશે',
  cardPerson: 'કોના વિશે',
  cardFrom: 'કોણે મોકલ્યું',
  cardNumbers: 'જરૂરી નંબર',
  cardContact: 'સંપર્ક',
  refKinds: {
    application: 'અરજી નંબર',
    certificate: 'દાખલા નંબર',
    consumer: 'ગ્રાહક નંબર',
    account: 'ખાતા નંબર',
    case: 'કેસ નંબર',
    reference: 'પત્ર નંબર',
    registration: 'નોંધણી નંબર',
    receipt: 'પહોંચ નંબર',
    other: 'નંબર'
  },
  requiredDocNames: {
    aadhaar: 'આધાર કાર્ડ',
    pan: 'પાન કાર્ડ',
    ration_card: 'રેશન કાર્ડ',
    voter_id: 'ચૂંટણી કાર્ડ (વોટર આઈડી)',
    passbook: 'બેંક પાસબુક',
    photo: 'ફોટો',
    income_certificate: 'આવકનો દાખલો',
    caste_certificate: 'જાતિનો દાખલો',
    domicile_certificate: 'રહેઠાણનો દાખલો',
    birth_certificate: 'જન્મનો દાખલો',
    land_record: 'જમીનનો રેકોર્ડ',
    electricity_bill: 'વીજળીનું બિલ',
    address_proof: 'સરનામાનો પુરાવો',
    id_proof: 'ઓળખનો પુરાવો',
    affidavit: 'સોગંદનામું (એફિડેવિટ)',
    application_form: 'અરજી ફોર્મ'
  },

  voiceDownloadNote: 'પહેલી વાર અવાજ ડાઉનલોડ થઈ રહ્યો છે (લગભગ 58 MB). પછી ઇન્ટરનેટ વગર પણ ચાલશે.',

  listen: 'સંભળાવો',
  pause: 'થોભો',
  resume: 'આગળ સંભળાવો',
  stop: 'બંધ કરો',
  noVoice: 'આ ફોનમાં ગુજરાતી અવાજ નથી.',
  noVoiceHint: 'ફોનના સેટિંગ (Text-to-speech) માં અવાજ ઉમેરી શકો છો, અથવા બીજી ભાષામાં સાંભળો.',
  listenInHindi: 'હિન્દીમાં સંભળાવો',
  listenInEnglish: 'અંગ્રેજીમાં સંભળાવો',
  noSpeechSupport: 'આ બ્રાઉઝર મોટેથી વાંચી શકતું નથી.',

  disclaimer: 'સમજો તમારા કાગળને સહેલો કરીને સમજાવે છે. જરૂરી વાતો હંમેશાં અસલ કાગળ કે તે આપનારી કચેરી સાથે મેળવી લો. સમજો સરકારી સેવા નથી અને આ કાનૂની સલાહ નથી.',
  fullText: 'સમજોએ શું વાંચ્યું',
  fullTextHint: 'રંગેલી લીટીઓ બરાબર વંચાઈ નથી.',
  newDocument: 'નવો કાગળ',
  save: 'આ ફોનમાં સેવ કરો',
  saved: 'આ ફોનમાં સેવ થઈ ગયું',
  share: 'શેર કરો',
  copied: 'કૉપી થઈ ગયું',
  translateLines: 'કાગળની અંગ્રેજી લીટીઓ ગુજરાતીમાં જુઓ',
  helperMode: 'હેલ્પર મોડ',
  helperModeHint: 'બીજાના કાગળ વાંચી આપનારા માટે (CSC, NGO, સ્વયંસેવકો). આમાં સેવ બંધ રહે છે, અને "આગલી વ્યક્તિ" દબાવતાં બધું ભૂંસાઈ જાય છે.',
  nextPerson: 'આગલી વ્યક્તિ',
  listenMode: 'સાંભળવાનો મોડ',
  listenModeHint: 'સમજૂતી તૈયાર થતાં જ સમજો તેને આપમેળે વાંચી સંભળાવે છે.',
  settingsTitle: 'સેટિંગ્સ',
  shareVoiceNote: 'વૉઇસ નોટ મોકલો',
  makingVoiceNote: 'વૉઇસ નોટ બની રહી છે…',
  voiceNoteFailed: 'આ ફોન પર વૉઇસ નોટ બની શકી નહીં.',
  translateOtherLines: 'કાગળની બીજી ભાષાની લીટીઓ ગુજરાતીમાં જુઓ',
  translateAiNote: 'જે લીટીઓ અંગ્રેજીમાં નથી, તેનો અનુવાદ એક AI સેવા (Groq) કરે છે.',
  translateConsent: 'અનુવાદ માટે આ લીટીઓ ઇન્ટરનેટથી સમજોના સર્વર પર મોકલાશે. ત્યાં તે સેવ થતી નથી. આધાર અને ફોન જેવા નંબર પહેલાં જ કાઢી નાખવામાં આવે છે.',
  translateConfirm: 'હા, અનુવાદ કરો',
  translating: 'અનુવાદ થાય છે…',
  translateNote: 'મશીનથી કરેલો અનુવાદ — ભૂલ હોઈ શકે.',
  translateFailed: 'હમણાં અનુવાદ થઈ શક્યો નથી.',
  retryRotated: 'ફોટો ફેરવીને ફરી વાંચો',

  addToCalendar: 'કૅલેન્ડરમાં રિમાઇન્ડર ઉમેરો',
  askTitle: 'આ કાગળ વિશે પૂછો',
  askHint: 'તમારા પોતાના શબ્દોમાં પૂછો. સમજો તમારા કાગળમાંથી જવાબ આપશે — અને ત્યાં ન હોય, તો ફક્ત સરકારી વેબસાઇટ પરથી.',
  askPlaceholder: 'તમારો પ્રશ્ન લખો અથવા બોલો…',
  askSend: 'પૂછો',
  askMic: 'બોલીને પૂછો',
  askListening: 'સાંભળે છે… હવે બોલો',
  askWebToggle: 'જરૂર હોય તો સરકારી વેબસાઇટ પણ જુઓ',
  askConsent: 'જવાબ આપવા માટે આ કાગળનું લખાણ અને તમારો પ્રશ્ન ઇન્ટરનેટથી સમજોના સર્વર અને એક AI સેવા (Groq) પર મોકલાશે. આધાર, પાન, ફોન નંબર અને ઈમેલ પહેલાં જ કાઢી નાખવામાં આવે છે. કશું સેવ થતું નથી.',
  askOfficialOnly: 'ફક્ત સરકારી વેબસાઇટ જોવાય છે, જેમ કે:',
  askConsentConfirm: 'ઠીક છે, પૂછો',
  askThinkingDoc: 'તમારો કાગળ વાંચી રહ્યા છીએ',
  askThinkingWeb: 'સરકારી વેબસાઇટ જોઈ રહ્યા છીએ',
  askFromDoc: 'તમારા કાગળમાંથી',
  askFromWeb: 'સરકારી વેબસાઇટ પરથી',
  askNotFound: 'સમજોને આ વાત તમારા કાગળમાં કે સરકારી વેબસાઇટ પર મળી નહીં. જે કચેરીએ આ કાગળ મોકલ્યો છે, તેમને પૂછો.',
  askUnverified: 'સમજો આને કાગળની કોઈ ચોક્કસ લીટી સાથે મેળવી શક્યું નહીં. કાગળ જોઈને તપાસી લો.',
  askSources: 'સ્રોત',
  askOfficial: 'સરકારી',
  askFailed: 'અત્યારે જવાબ મળી શક્યો નહીં. ફરી પ્રયત્ન કરો.',
  askBusy: 'અત્યારે ઘણા પ્રશ્નો આવી રહ્યા છે. એક મિનિટ રાહ જોઈ ફરી પૂછો.',
  askAiNote: 'આ જવાબો AI એ લખ્યા છે, ભૂલ હોઈ શકે. મહત્વની વાતો કચેરીમાંથી ખાતરી કરી લો.',
  askTryNext: 'તમે આ પણ પૂછી શકો:',
  askJump: 'પ્રશ્ન પૂછો',
  askSuggest: {
    fillForm: 'આ ફોર્મ કેવી રીતે ભરવું? દરેક ખાનું સમજાવો.',
    first: 'મારે પહેલાં શું કરવું જોઈએ?',
    deadline: 'છેલ્લી તારીખ ચૂકી જાઉં તો શું થશે?',
    pay: 'આ કેવી રીતે અને ક્યાં ભરવું?',
    papers: 'આ કાગળો ક્યાંથી મળશે?',
    rejected: 'આ કેમ નામંજૂર થયું, અને હવે હું શું કરી શકું?',
    meaning: 'આ કાગળ ખૂબ સરળ શબ્દોમાં સમજાવો.',
    contact: 'આ વિશે કોનો સંપર્ક કરું?',
    schemes: 'આ કાગળ મુજબ હું કઈ સરકારી યોજનાઓ માટે પાત્ર હોઈ શકું?'
  },

  helpTitle: 'મદદ મેળવો',
  nearbyTitle: 'સૌથી નજીકની કચેરી',
  nearbyNote: 'તમારી નજીકનો નકશો ખુલશે. તમારું લોકેશન ફક્ત નકશાને જાય છે — સમજો તેને જોતું નથી કે સાચવતું નથી.',
  locating: 'તમારું લોકેશન શોધી રહ્યા છીએ…',
  schemesTitle: 'સરકારી યોજનાઓ',
  schemesText: 'આ કાગળ મુજબ કઈ યોજનાઓ તમારા કામની હોઈ શકે, તે સમજો સરકારી યોજનાની વેબસાઇટ પર જોઈ શકે છે.',
  schemesButton: 'મારા માટે યોજનાઓ શોધો',
  legalTitle: 'મફત કાનૂની મદદ',
  legalText: 'કાનૂની સેવા સત્તામંડળ પાસેથી તમને મફત વકીલ મળી શકે — જેમ કે મહિલાઓ, બાળકો, SC/ST, મજૂરો, દિવ્યાંગો અને ઓછી આવકવાળા લોકો.',
  legalCall: (n) => `${n} પર ફોન કરો (મફત)`,
  legalNearby: 'સૌથી નજીકનું કાનૂની સેવા સત્તામંડળ',
  legalMore: 'વધુ કાનૂની મદદ',
  legalAskConsent: 'તમારો પ્રશ્ન ઇન્ટરનેટથી સમજોના સર્વર અને એક AI સેવા (Groq) પર મોકલાશે, જે જવાબ ફક્ત સરકારી વેબસાઇટ પર શોધે છે. આધાર, પાન, ફોન નંબર અને ઈમેલ પહેલાં જ કાઢી નાખવામાં આવે છે. કશું સેવ થતું નથી.',
  navLegal: 'કાનૂની મદદ'
}
